import React from 'react';
import { Box, Checkbox, InputLabel } from '@mui/material';
import { CheckboxOptionProps } from '../types';

export const CheckboxOption: React.FC<CheckboxOptionProps> = ({
  id,
  checked,
  onChange,
  label,
}) => {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <Checkbox
        id={id}
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        size="small"
        sx={{ p: 0.5, mr: 0.5 }}
      />
      <InputLabel
        htmlFor={id}
        sx={{ fontSize: '0.8rem', fontWeight: 500, color: 'text.primary' }}
      >
        {label}
      </InputLabel>
    </Box>
  );
};
